export default "__VITE_ASSET__f6017b62__"